import { takeLatest, call, put, StrictEffect, cancel, delay, select } from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';
import { apiInstance } from 'src/services/interceptor';
import { SagaIterator } from 'redux-saga';
import { getDashbardsList, getDashbardsListError, getDashbardsListSuccess, setSelectedCompanyofDashborad, setSelectedCompanyofDashboradError, setSelectedCompanyofDashboradSuccess, setSelectedDashboard, setSelectedDashboardError, setSelectedDashboardSuccess } from "./index"
import { dashboardType } from 'src/pages/DashboardPage';

interface PayloadProps {
  dashboard_id?: string,
  submitCallback?: (values?: any) => void;
  errorCallback?: (value: string) => void;
  company_id?: string
}

type DashboardType = {
  id: string,
  dashboardName: string,
  tenant_id: string,
}

function* setSelectedDashboardSaga({ payload: { dashboard_id, submitCallback, errorCallback } }: PayloadAction<PayloadProps>): SagaIterator {

  try {

    if (dashboard_id) {
      const dashboards = yield select(
        (state) => state.dashboardCharts?.dashboardsList
      );

      const selectedDashboard = dashboards.find((dash: dashboardType) => dash.id === dashboard_id) || null;
      const charts = yield call(apiInstance.get, `reporttool/dashboard/charts/${selectedDashboard?.id}`);
      const data = {
        dashboard: selectedDashboard, charts: charts?.data
      }
      localStorage.setItem('selectedDashboard', JSON.stringify(data))
      yield put(setSelectedDashboardSuccess(data));
      return
    }



    const currentDashboard = yield select(
      (state) => state.dashboardCharts.selectedDashboard?.dashboard
    );
    const dashboardList = yield select(
      (state) => state.dashboardCharts?.dashboardsList
    );
    const dashboards: DashboardType[] = dashboardList || [];

    let selectedDashboardFromStorage = null;
    try {
      selectedDashboardFromStorage = JSON.parse(localStorage.getItem('selectedDashboard') || 'null');
    } catch (e) {
      selectedDashboardFromStorage = null;
    }


    const dashID =
      selectedDashboardFromStorage?.dashboard?.id ||
      currentDashboard?.id ||
      (dashboardList.length > 0 ? dashboardList[0].id : null);

    if (!dashID) throw new Error('No dashboard ID available.');

    const charts = yield call(apiInstance.get, `reporttool/dashboard/charts/${dashID}`);
    const selectedDashboard = dashboardList.find((dash: dashboardType) => dash.id === dashID) || null;

    localStorage.setItem('selectedDashboard', JSON.stringify({
      dashboard: selectedDashboard,
      charts: charts?.data || []
    }))
    yield put(
      setSelectedDashboardSuccess({
        dashboard: selectedDashboard,
        charts: charts?.data || [],
      })
    );

    submitCallback?.();
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Unexpected error';
    errorCallback?.(errorMessage);
    yield put(
      setSelectedDashboardError()
    );
  }
}


function* getDashbardsListSaga({ payload: { submitCallback, errorCallback } }: PayloadAction<PayloadProps>): SagaIterator {

  try {
    const dashboardList = yield call(apiInstance.get, 'reporttool/dashboard/dashboards');
    if (dashboardList?.data) {
      yield put(
        getDashbardsListSuccess(dashboardList?.data)
      );
      submitCallback?.(dashboardList?.data)
      return
    }
    yield put(
      getDashbardsListError()
    );
    errorCallback?.(`Enable To get the Dashboards`);
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Unexpected error';
    errorCallback?.(errorMessage);
    yield put(
      getDashbardsListError()
    );
  }
}



function* setSelectedCompanyofDashboradSaga({ payload: { company_id, submitCallback, errorCallback } }: PayloadAction<PayloadProps>): SagaIterator {

  try {

    if (company_id) {

      const data = yield call(apiInstance.get, `reporttool/dashboard/company/${company_id}`);
      if (data?.data) {
        submitCallback?.(data?.data)
        yield put(
          setSelectedCompanyofDashboradSuccess({ ...data?.data , company_id })
        );
        return
      }
    }
    yield put(
      setSelectedCompanyofDashboradError(`Enable To get the Companies`)
    );
    errorCallback?.(`Enable To get the Companies`);
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Unexpected error';
    errorCallback?.(errorMessage);
    yield put(
      setSelectedCompanyofDashboradError(errorMessage)
    );
  }
}
function* watchDashboardCharts(): Generator<StrictEffect, void> {
  yield takeLatest(setSelectedDashboard.type, setSelectedDashboardSaga);
  yield takeLatest(getDashbardsList.type, getDashbardsListSaga);
  yield takeLatest(setSelectedCompanyofDashborad.type, setSelectedCompanyofDashboradSaga);
}


export { watchDashboardCharts };
